import {Radio as AntdRadio} from 'antd';

const Radio = ({invertValue, checked, ...props}) => (
  <AntdRadio checked={invertValue ? !checked : checked} {...props}/>
);

Radio.Button = AntdRadio.Button;
Radio.Group = AntdRadio.Group;

export default Radio;
